import { render } from "./ViewAssessmentTasks.vue?vue&type=template&id=5a2633b1&scoped=true"
import script from "./ViewAssessmentTasks.vue?vue&type=script&lang=js"
export * from "./ViewAssessmentTasks.vue?vue&type=script&lang=js"

import "./ViewAssessmentTasks.vue?vue&type=style&index=0&id=5a2633b1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a2633b1"]])

export default __exports__